import React from 'react'
import { Field, reduxForm } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { FormButtons, validations, renderers } from '../../components'
import { AuthenticationService } from '../../services'
let ForgotPasswordForm = ({
  onError,
  onSuccess,
  submitting,
  pristine,
  reset,
  handleSubmit,
}) => {
  const sendResetPasswordRequest = (values) => {
    AuthenticationService.initiatePasswordReset(values)
      .then((response) => {
        if (onSuccess) {
          onSuccess(response)
        }
      })
      .catch((error) => {
        if (onError) {
          onError(error)
        }
      })
  }
  return (
    <form onSubmit={handleSubmit(sendResetPasswordRequest)}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col className={'p-0'} xs="12">
          <Field
            name="email"
            label="Email"
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col className={'p-0'} xs="12">
          <FormButtons
            submitting={submitting}
            pristine={pristine}
            reset={reset}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </form>
  )
}
ForgotPasswordForm = reduxForm({
  form: 'ForgotPasswordForm',
})(ForgotPasswordForm)

export default ForgotPasswordForm
